import React from 'react';

export default class PipedPanelConnector extends React.Component {

  render() {
    return (
      <div className="PipedPanelConnector row">
        <div className="col-xs-16">
          <div className="strokes">
            <div className="stroke vertical left"></div>
            <div className="stroke vertical right"></div>
          </div>
        </div>
      </div>
    );
  }

};
